<template>
    <section>
        <canvas ref="historyChart"></canvas>
    </section>
</template>

<script>
    import Chart from 'chart.js'
    import moment from 'moment'

    const update = function (x, y, count) {
        const size = x.length
        const result = []

        const start = size > 0 ? moment(x[0], 'YY-MM-DDTHH:mm').unix() : 0

        for (let i = 0; i < size; i++) {
            let tweets = count[i]
            result.push({
                x: (moment(x[i], 'YY-MM-DDTHH:mm').unix() - start) / 60,
                y: y[i],
                tweets: tweets,
                r: Math.sqrt((tweets * 2 * Math.PI * 2 * 2) / (2 * Math.PI))
            })
        }
        return result
    }

    export default {
        name: 'SentimentHistory',
        props: ['data'],
        data () {
            return {
                historyChart: null
            }
        },
        watch: {
            data () {
                this.drawHistoryChart()
            }
        },
        methods: {
            drawHistoryChart () {
                const ctx = this.$refs.historyChart
                const start = this.data.positive.length > 0 ? moment(this.data.labels[0], 'YY-MM-DDTHH:mm') : false
                this.historyChart = new Chart(ctx, {
                    type: 'bubble',
                    data: {
                        labels: this.data.labels,
                        datasets: [
                            {
                                label: 'positive tweets', // 5eb408
                                borderColor: 'rgba(94,180,8,1)',
                                backgroundColor: 'rgba(94,180,8,0.2)',
                                data: update(this.data.labels, this.data.positive, this.data.count_positive)
                            },
                            {
                                label: 'negative tweets',
                                borderColor: 'rgba(229, 6, 32, 1)',
                                backgroundColor: 'rgba(229, 6, 32, 0.2)',
                                data: update(this.data.labels, this.data.negative, this.data.count_negative)
                            }
                        ]
                    },
                    options: {
                        tooltips: {
                            callbacks: {
                                label: function (tooltipItem, data) {
                                    const date = start.clone()
                                    date.add(tooltipItem.x, 'minute')
                                    const tweets = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
                                    const label = `${date.format('MM/DD/YYYY HH:mm')}, ` +
                                     `${tweets.tweets} ${data.datasets[tooltipItem.datasetIndex].label}, avg. ` +
                                      `sentiment ${tooltipItem.yLabel}`
                                    return label
                                }
                            }
                        },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    callback: function (value, index, values) {
                                        const date = start.clone()
                                        date.add(value, 'minute')
                                        return date.format('MM/DD/YYYY HH:mm')
                                    }
                                }
                            }],
                            yAxes: [{
                                ticks: {
                                    min: -1,
                                    max: 1,
                                    stepSize: 0.1,
                                    callback: function (value, index, values) {
                                        if (index === 0) {
                                            return 'Very positive'
                                        } else if (index === values.length - 1) {
                                            return 'Very negative'
                                        }
                                        if (value === 0) {
                                            return 'Neutral'
                                        }
                                        return null
                                    }
                                }
                            }]
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SentimentHistory.vue